// import { E } from '@angular/cdk/keycodes';
// import { ConditionalExpr } from '@angular/compiler';
// import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
// import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
// import { DomSanitizer } from '@angular/platform-browser';
// import { ActivatedRoute, Router } from '@angular/router';
// import { Observable } from 'rxjs';
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
// import { ApiService } from 'src/app/Services/api.service';
// import { CommonServices } from 'src/app/Services/common.service';
// import { FileUploadService } from 'src/app/Services/file-upload.service';
// import { LoaderService } from 'src/app/Services/loader.service';
// import { MapService } from 'src/app/Services/map.service';
// import { SharedService } from 'src/app/Services/shared.service';
// import { StorageService } from 'src/app/Services/storage.service';
// import { SweetAlert } from 'src/app/Services/sweetalet.service';

// @Component({
//   selector: 'app-editvehicle',
//   templateUrl: './editvehicle.component.html',
//   styleUrls: ['./editvehicle.component.css']
// })
// export class EditvehicleComponent implements OnInit {

//   public breadcrumbData = {
//     "Information": "/organization/transport-manager/information",
//     "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
//   };
//   matFormSize = '13px';
//   editVehicelForm: FormGroup;
//   orgID: string;
//   vendorID: string;
//   vehicleID: string;
//   EditFormData: any;
//   public mapObj: any;

//   isLocationMandatory: boolean = false;

//   public vehicleEditObj = {};
//   isShowSimno = false;
//   isShowVendorName = false;
//   public ignoreBoxUpdate: boolean = true;
//   strDate: any;
//   purchDate: any;
//   rcStrDate: any;
//   roadTaxStatus: any;

//   public editLocation: boolean = true;
//   public vehicleLocation = {};
//   public locationData = {};

//   VendorInfos: any;
//   routerLinks: any;

//   //for remarks field 
//   public isRemarksShown: boolean = false;
//   //update
//   public remarkError: any = 'You must change the remarks';
//   public showRemarkError: boolean = false;

//   public fieldOptions = {
//     model: [
//       { name: "Hatchback", value: "Hatchback", capacity: 3, max: 3 },
//       { name: "Sedan", value: "Sedan", capacity: 4, max: 4 },
//       { name: "SUV", value: "SUV", capacity: 7, max: 7 },
//       { name: "Van", value: "Van", capacity: 15, max: 15 },
//       { name: "Bus", value: "Bus", capacity: 60, max: 60 },
//       { name: "Auto", value: "Auto", capacity: 3, max: 3 },
//       { name: "Load Vehicle", value: "loadVehicle", capacity: 2, max: 100 }
//     ],
//   };

//   public updateValues = [];
//   formSubmit: boolean = false;
//   public errorObject: any = {};

//   // rc
//   imageData: File | string = null;
//   filePreview: string | null = null;
//   rcContentType: string | null = null;
//   @ViewChild('rcfile') rcfile: ElementRef;

//   // fc
//   fcImage: File | string = null;
//   fcPreview: string | null = null;
//   fcContentType: string | null = null;
//   @ViewChild('fcfile') fcfile: ElementRef;

//   // puc
//   pucImage: File | string = null;
//   pucPreview: string | null = null;
//   pucContentType: string | null = null;
//   @ViewChild('pucfile') pucfile: ElementRef;

//   // ins 
//   insuranceImage: File | string = null;
//   insPreview: string | null = null;
//   insContentType: string | null = null;
//   @ViewChild('insurancefile') insurancefile: ElementRef;

//   /* Branch field */
//   public branchLists: any = [];
//   public selectedBranch = [];
//   @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
//   branchSearchChangeObserver: any;
//   public enableBranchField: boolean = false;
//   public branchSearchVal: any = '';

//   public status: any = '';
//   public remarks: any = '';
//   public viewOption: any = '';
//   public isStatusChanged: boolean = false;
//   @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

//   public vehCapacity: any = {};
//   fuelType: any;
//   updateFile: boolean;
//   updateFileFc: boolean;
//   updateFileIns: boolean;
//   updateFilePuc: boolean;
//   imageUrl: any = [];
//   minDate: Date;
//   safePdfUrl: any;
//   constructor(
//     public api: ApiService,
//     public router: Router,
//     public route: ActivatedRoute,
//     public swal: SweetAlert,
//     public sub: SharedService,
//     public fb: FormBuilder,
//     private mapService: MapService,
//     public file: FileUploadService,
//     public storage: StorageService,
//     public comService: CommonServices,
//     private renderer: Renderer2,
//     public el: ElementRef,
//     private sanitizer: DomSanitizer,
//     public loader:LoaderService
//   ) {

//     this.route.paramMap.subscribe((params: any) => {
//       this.vendorID = params.params.vendorID;
//       this.vehicleID = params.params.vehicleID;
//       if (params.params['view']) this.viewOption = params.params.view;

//     });
//     this.orgID = this.storage.get('userInfo').orgID;
//     this.VendorInfos = this.storage.get('vendorID_orgID');

//     let vendorName = this.VendorInfos['vendorName'];
//     if (vendorName) {
//       vendorName = this.comService.strTruncate(vendorName, 13);
//       this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
//     } else {
//       this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
//     }
//     this.breadcrumbData['Vehicles'] = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
//     this.breadcrumbData['Edit'] = '';

//     this.routerLinks = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
//     // const fileInput = this.fileInput.nativeElement as HTMLInputElement;
//     // this.renderer.setProperty(fileInput, 'value', '');

//   }

//   ngOnInit(): void {
//     this.getVehCapacity();
//     this.getBranchList();
//     this.editFormLoad();
//     this.getVehicleData();
//     this.minDate = new Date()
//   }
//   editFormLoad() {
//     this.editVehicelForm = new FormGroup({
//       vehRegNo: new FormControl('', [Validators.required, Validators.pattern('[A-Z|a-z]{2}[0-9]{1,2}[A-Z|a-z]{0,2}[0-9]{4}')]),
//       imei: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[0-9|a-z|A-Z]*$')]),
//       make: new FormControl(''), /* , [Validators.required]), */
//       model: new FormControl('', [Validators.required]),
//       capacity: new FormControl('', [Validators.required, Validators.min(1), Validators.max(100)]),
//       branch: new FormControl('', [Validators.required]),
//       vehicleType: new FormControl(''), /* , [Validators.required]), */
//       chassisNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
//       engineNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
//       vehRegDate: new FormControl(''), /* , [Validators.required]), */
//       routePermitNo: new FormControl(''),
//       startDate: new FormControl(''), /* [Validators.required]), */
//       expiryDate: new FormControl(''), /* [Validators.required]), */
//       rcNo: new FormControl(''), /* [Validators.required]), */
//       vehicleInfo: new FormControl(''), /* [Validators.required]), */
//       location: new FormControl(''), /* [Validators.required]), */
//       isActive: new FormControl('', [Validators.required]),
//       remarks: new FormControl({ value: this.remarks, disabled: true }, [Validators.required]),
//       boxType: new FormControl('', [Validators.required]),
//       roadTaxStatus: new FormControl(''), /* [Validators.required]), */
//       fuelType: new FormControl(''),
//       fcfile: new FormControl(null),/* [Validators.required]), */
//       insurancefile: new FormControl(null),/* [Validators.required]), */
//       pucfile: new FormControl(null),/* [Validators.required]), */
//       rcfile: new FormControl(null), /* [Validators.required]), */
//       rcStartDate: new FormControl('', [Validators.required]),
//       rcExpiryDate: new FormControl('', [Validators.required]),
//       pucExpiryDate: new FormControl('', [Validators.required]),
//       fcExpiryDate: new FormControl('', [Validators.required]),
//       insuranceExpiryDate: new FormControl('', [Validators.required]),
//     });
//     if (this.viewOption == 'view') {
//       this.editVehicelForm.get('imei')?.disable()
//       const controlNames = Object.keys(this.editVehicelForm.controls);
//       controlNames.forEach(controlName => {
//         this.editVehicelForm.get(controlName)?.disable();
//       });
//     }
//   }


//   getVehicleData() {

//     const obj = {
//       orgID: this.orgID,
//       vendorID: this.vendorID,
//       vehicleID: this.vehicleID
//     };

//     this.api.transportManagerVehicleList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         const obj = res.data[0];
//         this.EditFormData = res.data[0];
//         const data = res.data[0];

//         this.status = data['isActive'];
//         this.setValueEditVehicleForm(data);
//       }
//     }).catch((err) => {
//       console.log(err);
//     });

//   }
//   getVehCapacity() {
//     this.api.transportManagerVehicleCapacity({}).then((res: any) => {
//       if (res.status == 'success' && res.data.length > 0 && res.data[0].vehicleTypes.length > 0) {
//         this.vehCapacity = res.data[0].vehicleTypes;
//         this.fuelType = res.data[0].fuelType;
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   setValueEditVehicleForm(data) {
//     if (data['boxType'] && data['boxType'] != '') this.onChangeBoxType({ value: data['boxType'] }, 'boxType');
//     if (data['model'] && data['model'] != '') this.patchVehicleCapacity({ value: data['model'] }, 'patch');
//     if (data['location'] && data['location'] != '') this.locationData = { ...data['location'] };

//     (data['rcfile'] && data['rcfile'] != '') && (data['rcContentType'] != undefined) ? this.rcContentType = data['rcContentType'] : data['rcContentType'] == undefined ? this.rcContentType = 'Image' : '';

//     data['fcfile'] && data['fcfile'] != '' && (data['fcContentType'] != undefined) ? this.fcContentType = data['fcContentType'] : data['fcContentType'] == undefined ? this.fcContentType = 'Image' : '';

//     data['pucfile'] && data['pucfile'] != '' && (data['pucContentType'] != undefined) ? this.pucContentType = data['pucContentType'] : data['pucContentType'] == undefined ? this.pucContentType = 'Image' : '';

//     data['insfile'] && data['insfile'] != '' && (data['insContentType']) ? this.insContentType = data['insContentType'] : data['insContentType'] == undefined ? this.insContentType = 'Image' : '';

//     this.imageData = this.filePreview = data['rcfile'] && data['rcfile'] !== '' ? data['rcfile'] + '?ts=' + Date.now() : '';

//     this.fcImage = this.fcPreview = data['fcfile'] && data['fcfile'] !== '' ? data['fcfile'] + '?ts=' + Date.now() : '';

//     this.pucImage = this.pucPreview = data['pucfile'] && data['pucfile'] !== '' ? data['pucfile'] + '?ts=' + Date.now() : '';

//     this.insuranceImage = this.insPreview = (data['insfile'] && data['insfile'] !== '') || (data['insurancefile'] && data['insurancefile'] !== '')
//       ? (data['insfile'] || data['insurancefile']) + '?ts=' + Date.now()
//       : '';

//     if (data['branch'] && !Array.isArray(data['branch'])) this.getBranchList('', data['branch']);

//     this.remarks = data['msgLog'] && data['msgLog'].length > 0 && data['msgLog'][data['msgLog'].length - 1] && data['msgLog'][data['msgLog'].length - 1]['msg'] ? data['msgLog'][data['msgLog'].length - 1]['msg'] : '';

//     this.editVehicelForm.patchValue({
//       vehRegNo: data['vehRegNo'] ? data['vehRegNo'] : '',
//       imei: data['imei'] ? data['imei'].toLowerCase() : '',
//       make: data['make'] ? data['make'] : '',
//       model: data['model'] ? data['model'] : '',
//       capacity: data['capacity'] ? data['capacity'] : '',
//       branch: data['branch'] ? data['branch'] : '',
//       vehicleType: data['vehicleType'] ? data['vehicleType'] : '',
//       chassisNo: data['chassisNo'] ? data['chassisNo'] : '',
//       engineNo: data['engineNo'] ? data['engineNo'] : '',
//       vehRegDate: data['vehRegDate'] ? new Date(data['vehRegDate']) : '',
//       routePermitNo: data['routePermitNo'] ? data['routePermitNo'] : '',
//       startDate: data['startDate'] ? new Date(data['startDate']) : '',
//       expiryDate: data['expiryDate'] ? new Date(data['expiryDate']) : '',
//       rcNo: data['rcNo'] ? data['rcNo'] : '',
//       rcStartDate: data['rcStartDate'] ? new Date(data['rcStartDate']) : '',
//       rcExpiryDate: data['rcExpiryDate'] ? new Date(data['rcExpiryDate']) : '',
//       fcExpiryDate: data['fcExpiryDate'] ? new Date(data['fcExpiryDate']) : '',
//       pucExpiryDate: data['pucExpiryDate'] ? new Date(data['pucExpiryDate']) : '',
//       insuranceExpiryDate: data['insuranceExpiryDate'] ? new Date(data['insuranceExpiryDate']) : '',
//       vehicleInfo: data['vehicleInfo'] ? data['vehicleInfo'] : '',
//       location: data['location'] && data['location']['name'] ? data['location']['name'] : '',
//       boxType: data['boxType'] ? data['boxType'] : '',
//       vendorName: data['vendorName'] ? data['vendorName'] : '',
//       simNo: data['simNo'] ? data['simNo'] : '',
//       isActive: data['isActive'] || data.isActive == false ? data.isActive.toString() : '',
//       remarks: this.remarks,
//       roadTaxStatus: data['roadTaxStatus'] || data.roadTaxStatus == false ? data.roadTaxStatus.toString() : '',
//       fuelType: data['fuelType'] ? data['fuelType'] : '',
//       rcfile: data['rcfile'] ? data['rcfile'] : '',
//       insurancefile: data['insurancefile'] ? data['insurancefile'] : data['insfile'] ? data['insfile'] : '',
//       pucfile: data['pucfile'] ? data['pucfile'] : '',
//       fcfile: data['fcfile'] ? data['fcfile'] : '',
//     });
//     if (data['branch'] && !Array.isArray(data['branch'])) {
//       setTimeout(() => {
//         this.branchSelectionResult(data['branch']);
//       }, 300);
//     }
//     this.ignoreBoxUpdate = false;
//   }

//   getBranchList(name?, branch?) {
//     this.enableBranchField = false;
//     this.branchLists = [];
//     const obj = {};
//     if (name && name != '') obj['branchName'] = name;
//     if (branch) obj['branchID'] = branch;

//     this.api.transportManagerBranchList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         if (res.data && res.data.length > 0) {
//           res.data.filter(item => {
//             try {
//               if (item.branchName && item.branchID) {
//                 let branchObj = {
//                   name: item.branchName,
//                   value: item.branchID,
//                 };
//                 let pushObj: boolean = true;
//                 if (this.selectedBranch.length > 0) {
//                   this.selectedBranch.map((item) => { if (item.value == branchObj.value) { pushObj = false; } });
//                 }
//                 if (pushObj) this.branchLists.push(branchObj);

//               }
//             } catch (err) {
//               console.log('branch', err);
//             }
//           });
//         }
//       }
//       setTimeout(() => { this.enableBranchField = true }, 200);
//     }).catch((err) => {
//       // console.log(err);
//     });
//   }

//   // search
//   branchSearchChange(searchValue: string) {
//     searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

//     if (!this.branchSearchChangeObserver) {
//       new Observable(observer => {
//         this.branchSearchChangeObserver = observer;
//       }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
//         .pipe(distinctUntilChanged()) // only emit if value is different from previous value
//         .subscribe((term: any) => {
//           // your code here
//           this.getBranchList(term);
//         });
//     }

//     this.branchSearchChangeObserver.next(searchValue);
//   }

//   branchSelectionResult(value) {
//     if (!Array.isArray(value)) value = [value];
//     let result = [];
//     let removedResult = [];
//     for (let i = 0; i < value.length; i++) {
//       let val = value[i];
//       this.selectedBranch.map((item) => {
//         if (item.value == val) {
//           let valIndex = result.findIndex((e) => e.value == item.value);
//           if (valIndex == -1) result.push(item);
//         }
//       })
//       this.branchLists.map((veh) => {
//         if (veh.value == val) {
//           let valIndex = result.findIndex((e) => e.value == veh.value);
//           if (valIndex == -1) result.push(veh);
//         }
//       })
//     }
//     this.selectedBranch.map((branch) => {
//       if (!value.includes(branch.value)) {
//         let pushObj: boolean = true;
//         removedResult.map((e) => { if (e.value == branch.value) pushObj = false; });
//         if (pushObj) removedResult.unshift(branch);
//       }
//     })
//     this.enableBranchField = false;
//     this.branchLists = [...removedResult, ...this.branchLists]
//     this.enableBranchField = true;

//     this.selectedBranch = [...result];
//     if (this.branchSearchTextBox && this.branchSearchTextBox.nativeElement)
//       this.branchSearchTextBox.nativeElement.value = '';
//     this.clearDuplicates();
//   }

//   clearDuplicates() {
//     let result = [];
//     this.enableBranchField = false;
//     this.branchLists.map((branchObj) => {

//       let pushObj: boolean = true;
//       this.selectedBranch.map((item) => { if (item.value == branchObj.value) pushObj = false; });
//       if (pushObj) result.push(branchObj);

//     });
//     this.branchLists = [...result];
//     this.enableBranchField = true;
//   }

//   clearBranchSearch(event) {
//     this.branchSearchTextBox.nativeElement.value = '';
//     this.getBranchList();
//   }

//   _keyPress(event: any) {
//     const pattern = /[0-9]/;
//     const inputChar = String.fromCharCode(event.charCode);
//     if (!pattern.test(inputChar)) {
//       event.preventDefault();

//     }
//   }

//   patchVehicleCapacity(e, type) {
//     this.fieldOptions['model'].filter((option: any) => {
//       if (option.value == e.value) {
//         this.editVehicelForm.controls['capacity'].setValidators([Validators.required, Validators.min(1), Validators.max(option.max)])
//         if (type != 'patch') this.editVehicelForm.controls['capacity'].patchValue(option.capacity);
//         if (type == 'update') this.updateField('capacity', parseInt(option.capacity));
//       }
//     })
//   }

//   onChangeBoxType(e, field) {
//     // console.log('boxValue',e.value);
//     this.isShowVendorName = false;
//     this.isShowSimno = false;
//     if (e.value == 'others') {
//       this.editVehicelForm.removeControl('simNo');
//       this.editVehicelForm.addControl('vendorName', new FormControl('')); /* , [Validators.required])); */
//       this.isShowVendorName = true;
//     }
//     if (e.value == 'G10 Gps Device') {
//       this.editVehicelForm.removeControl('vendorName');
//       this.editVehicelForm.addControl('simNo', new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13)]));
//       this.isShowSimno = true;
//     }

//     if (!this.ignoreBoxUpdate) this.fieldChange(e, 'dropdown', field);

//   }

//   getLocation(obj) {
//     this.vehicleLocation = { ...obj };
//     this.fieldChange(this.vehicleLocation, 'location', 'location');
//   }

//   // file upload--------------

//   async handleUpload(event: Event, type: string) {
//     const file = (event.target as HTMLInputElement).files?.[0];
//     const maxFileSizeInMB = 1;
//     const maxFileSize = maxFileSizeInMB * 1024 * 1024;
//     const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
//     const allowedPdfType = 'application/pdf';

//     if (!file) return;

//     const fileType = file.type;
//     const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

//     if (!isImageOrPdf) {
//       this.handleInvalidFileType(type);
//       return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
//     }

//     if (file.size > maxFileSize) {
//       this.handleFileSizeExceeded(type);
//       return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
//     }

//     this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

//     if (this.formSubmit) this.validation();
//   }

//   private processFile(file: File, type: string, fileType: string, contentType: string) {
//     const fileReader = new FileReader();
//     fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
//     fileReader.readAsDataURL(file);
//   }

//   private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
//     switch (type) {
//       case 'rcfile':
//         this.imageData = file;
//         this.rcContentType = contentType;
//         this.filePreview = previewData;
//         this.updateFile = true;
//         this.editVehicelForm.controls.rcfile.patchValue(file);
//         break;
//       case 'fcfile':
//         this.fcImage = file;
//         this.fcContentType = contentType;
//         this.fcPreview = previewData;
//         this.updateFileFc = true;
//         this.editVehicelForm.controls.fcfile.patchValue(file);
//         break;
//       case 'pucfile':
//         this.pucImage = file;
//         this.pucContentType = contentType;
//         this.pucPreview = previewData;
//         this.updateFilePuc = true;
//         this.editVehicelForm.controls.pucfile.patchValue(file);
//         break;
//       case 'insurancefile':
//         this.insuranceImage = file;
//         this.insContentType = contentType;
//         this.insPreview = previewData;
//         this.updateFileIns = true;
//         this.editVehicelForm.controls.insurancefile.patchValue(file);
//         break;
//     }
//   }

//   private handleInvalidFileType(type: string) {
//     this.resetFileFields(type);
//   }

//   private handleFileSizeExceeded(type: string) {
//     this.resetFileFields(type);
//   }

//   private resetFileFields(type: string) {
//     switch (type) {
//       case 'rcfile':
//         this.imageData = null;
//         this.filePreview = null;
//         this.rcContentType = null;
//         this.editVehicelForm.controls.rcfile.reset();
//         this.clearInputField(this.rcfile);
//         break;
//       case 'fcfile':
//         this.fcImage = null;
//         this.fcPreview = null;
//         this.fcContentType = null;
//         this.editVehicelForm.controls.fcfile.reset();
//         this.clearInputField(this.fcfile);
//         break;
//       case 'pucfile':
//         this.pucImage = null;
//         this.pucPreview = null;
//         this.pucContentType = null;
//         this.editVehicelForm.controls.pucfile.reset();
//         this.clearInputField(this.pucfile);
//         break;
//       case 'insurancefile':
//         this.insuranceImage = null;
//         this.insPreview = null;
//         this.insContentType = null;
//         this.editVehicelForm.controls.insurancefile.reset();
//         this.clearInputField(this.insurancefile);
//         break;
//     }
//   }

//   private clearInputField(inputElement: ElementRef) {
//     if (inputElement) inputElement.nativeElement.value = '';
//   }

//   private showErrorMessage(message: string) {
//     this.swal.swalFunction('error', 'error', message, 5000);
//   }

//   reUpload(field: string) {
//     const fileFieldMap = {
//       'rcfile': this.rcfile,
//       'fcfile': this.fcfile,
//       'pucfile': this.pucfile,
//       'insurancefile': this.insurancefile
//     };

//     const fileInput = fileFieldMap[field];
//     if (fileInput) {
//       fileInput.nativeElement.click();
//     }
//   }

//   cancelImage(type: string) {
//     if (type == 'rcfile') {
//       this.editVehicelForm.controls.rcfile.patchValue('');
//       this.imageData = undefined;
//     } if (type == 'fcfile') {
//       this.editVehicelForm.controls.fcfile.patchValue('');
//       this.fcImage = undefined;
//     } if (type == 'pucfile') {
//       this.editVehicelForm.controls.pucfile.patchValue('');
//       this.pucImage = undefined;
//     } if (type == 'insurancefile') {
//       this.editVehicelForm.controls.insurancefile.patchValue('');
//       this.insuranceImage = undefined;
//     }
//   }

//   // check Error in form field
//   public checkError = (controlName: string, errorName: string) => {
//     if (errorName == 'matDatepickerMin') {
//     }
//     return this.editVehicelForm.controls[controlName].hasError(errorName);
//   }
//   validation() {
//     this.errorObject = {};
//     let fields = Object.keys(this.editVehicelForm.controls);
//     fields.map((field) => {
//       if (this.checkError(field, 'required')) {
//         this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required';
//         if (field == 'vehRegNo') this.errorObject[field] = 'Registration No is required';
//         else if (field == 'imei') this.errorObject[field] = 'IMEI is required';
//         else if (field == 'vehicleType') this.errorObject[field] = 'Vehicle Type is required';
//         else if (field == 'chassisNo') this.errorObject[field] = 'Chassis No is required';
//         else if (field == 'engineNo') this.errorObject[field] = 'Engine No is required';
//         else if (field == 'vehRegDate') this.errorObject[field] = 'Purchased Date is required';
//         else if (field == 'routePermitNo') this.errorObject[field] = 'Route Permit Cost is required';
//         else if (field == 'startDate') this.errorObject[field] = 'Start Date is required';
//         else if (field == 'expiryDate') this.errorObject[field] = 'Expiry Date is required';
//         else if (field == 'rcNo') this.errorObject[field] = 'RC Book No is required';
//         else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start Date is required';
//         else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC Expiry Date is required';
//         else if (field == 'vehicleInfo') this.errorObject[field] = 'Vehicle Info is required';
//         else if (field == 'boxType') this.errorObject[field] = 'Box Type is required';
//         else if (field == 'isActive') this.errorObject[field] = 'Status is required';
//         else if (field == 'remarks') this.errorObject[field] = 'Remarks is required';
//         else if (field == 'vendorName') this.errorObject[field] = 'Vendor Name is required';
//         else if (field == 'simNo') this.errorObject[field] = 'SIM No is required';
//         else if (field == 'roadTaxStatus') this.errorObject[field] = 'Road Tax Paid is required';
//         else if (field == 'rcfile') this.errorObject[field] = 'RC File is required';
//         else if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date  is required';
//         else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date is required';
//         else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date is required';
//         else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date is required';
//         else if (field == 'fuelType') this.errorObject[field] = 'Fuel type is required';
//       }
//       else if (field == 'vehRegNo') {
//         if (this.checkError(field, 'pattern')) this.errorObject[field] = 'Registration No is Incorrect';
//       } else if (field == 'imei' || field == 'chassisNo' || field == 'engineNo' || field == 'routePermitNo') {
//         if (this.checkError(field, 'minlength')) {
//           if (field == 'imei') this.errorObject[field] = "IMEI should be above 3 characters";
//           else if (field == 'chassisNo') this.errorObject[field] = "Chassis No should be more than 17 characters";
//           else if (field == 'engineNo') this.errorObject[field] = "Engine No should be more than 17 characters";
//           else if (field == 'routePermitNo') this.errorObject[field] = "Route Permit Cost should be minimum than 4 digits";
//         } else if (this.checkError(field, 'maxlength')) {
//           if (field == 'imei') this.errorObject[field] = "IMEI should be less than 50 characters";
//           else if (field == 'routePermitNo') this.errorObject[field] = "Route Permit Cost should be more than 7 digits";
//         }
//         else if (this.checkError(field, 'pattern')) {
//           if (field == 'imei') this.errorObject[field] = "IMEI should be valid";
//         }
//       } else if (field == 'capacity') {
//         if (this.checkError(field, 'min')) this.errorObject[field] = "Minimum capacity is required";
//         else if (this.checkError(field, 'max')) this.errorObject[field] = "Maximum capacity is reached";
//       }
//       if (['rcStartDate', 'fcExpiryDate', 'pucExpiryDate', 'insuranceExpiryDate', 'rcExpiryDate'].includes(field) && this.editVehicelForm.get(field).value) {
//         const selectedDate = new Date(this.editVehicelForm.get(field).value);
//         const currentDate = new Date();
//         currentDate.setHours(0, 0, 0, 0); // Only compare the date part, ignore time

//         if (selectedDate < currentDate) {
//           if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date must not be in the past';
//           else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date must not be in the past';
//           else if (field == 'rcStartDate') this.errorObject[field] = 'RC start date must not be in the past';
//           else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date must not be in the past';
//           else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date must not be in the past';
//         }
//       }
//       else if (field == 'remarks' || field == 'status') {
//         if (this.isStatusChanged) {
//           if (this.EditFormData.remarks == this.editVehicelForm.value.remarks) {
//             this.errorObject.remarks = 'You must change the remarks';
//             this.editVehicelForm.controls['remarks'].setErrors({ 'incorrect': true });
//           }
//         }
//       }
//     })
//   }

//   /* update unique field*/
//   fieldChange(e: any, type, field) {
//     let value: any;
//     if (type == 'text' || type == 'textarea') {
//       value = e.target.value;
//       if (field == 'vehRegNo') value = String(e.target.value).toUpperCase();
//       if (field == 'simNo') value = parseInt(value);
//       if (field == 'remarks') {
//         if (!this.isStatusChanged) value = this.remarks;
//       }
//     }
//     if (type == 'date') {
//       value = new Date(e.value).getTime();
//     }
//     if (type == 'dropdown') {
//       value = e.value;
//       if (field == 'roadTaxStatus') {
//         if (value == 'true') value = true;
//         else value = false;
//       }
//       if (field == 'model') {
//         this.patchVehicleCapacity(e, 'update');
//       }
//       if (field == 'branch') {
//         this.branchSelectionResult(value);
//       }
//       if (field == 'isActive') {
//         this.isStatusChanged = true;
//         let remarks: any = this.editVehicelForm.get('remarks');
//         if (this.status === (value === 'true')) {
//           this.isStatusChanged = false;
//           this.editVehicelForm.patchValue({
//             remarks: this.remarks
//           });
//           this.editVehicelForm.controls['remarks'].disable();
//           // this.editVehicelForm.addControl('remarks', new FormControl({ value: this.remarks, disabled: true }, [Validators.required]));
//         } else {
//           remarks.reset('');
//           this.editVehicelForm.controls['remarks'].enable();
//           // this.editVehicelForm.addControl('remarks', new FormControl({ value: '', disabled: false }));
//         }
//       }
//     }
//     if (type == 'location' || type == 'file') {
//       value = e;
//     }
//     if (field && (value != undefined)) this.updateField(field, value);
//     if (this.formSubmit) this.validation();
//   }

//   updateField(field, value) {
//     let editObjKeys = Object.keys(this.EditFormData);

//     if (this.updateValues.length > 0) {
//       let filterUpdate = this.updateValues.filter((e) => e.field != field);
//       let obj = { field: field, value: value, };
//       if (field == 'isActive') {
//         obj.value = (value === 'true');
//       }
//       this.updateValues = [
//         ...filterUpdate,
//         obj,
//       ]
//     }
//     else {
//       let obj = { field: field, value: value, };
//       if (field == 'isActive') {
//         obj.value = (value === 'true');
//       }
//       this.updateValues.push(obj);
//     }
//     for (let i = 0; i < editObjKeys.length; i++) {
//       for (let j = 0; j < this.updateValues.length; j++) {
//         if (editObjKeys[i] === this.updateValues[j]['field'] && this.EditFormData[editObjKeys[i]] === this.updateValues[j]['value']) {
//           const index = this.updateValues.findIndex(e => (e.field == editObjKeys[i] && e.value == this.EditFormData[editObjKeys[i]]))
//           this.updateValues.splice(index, 1);
//         }
//       }
//     }
//   }

//   onFileSelected(event: any) {
//     const fileInput = this.fileInput.nativeElement as HTMLInputElement;
//     this.renderer.setProperty(fileInput, 'value', '');
//   }
//   onSubmit() {
//     this.formSubmit = true;
//     this.validation();
//     // if (!this.editVehicelForm.valid) return;
//     if (this.editVehicelForm.valid && this.updateValues.length > 0 || this.updateFile == true || this.updateFileFc == true || this.updateFileIns == true || this.updateFilePuc == true) {
//       const obj = {
//         orgID: this.orgID,
//         vendorID: this.vendorID,
//         vehicleID: this.vehicleID,
//       };

//       if (this.editVehicelForm.value['vehRegNo']) obj['vehRegNo'] = this.editVehicelForm.value['vehRegNo'];

//       this.updateValues.filter((e) => {
//         obj[e.field] = e.value;
//       });
//       if (this.updateFile == true) {
//         obj['rcFiles'] = this.imageData;
//         obj['rcContentType'] = this.rcContentType;
//       }
//       if (this.updateFileFc == true) {
//         obj['fcFiles'] = this.fcImage;
//         obj['fcContentType'] = this.fcContentType;
//       };
//       if (this.updateFileIns == true) {
//         obj['insFiles'] = this.insuranceImage;
//         obj['insContentType'] = this.insContentType;
//       }
//       if (this.updateFilePuc == true) {
//         obj['pucFiles'] = this.pucImage;
//         obj['pucContentType'] = this.pucContentType;
//       };

//       delete obj['pucfile'];
//       delete obj['fcfile'];
//       delete obj['rcfile'];
//       delete obj['insurancefile'];

//       let url = 'organization/vehicle/updateVehicle';
//       this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
//         if (res['responseJSON']['status'] == 'success') {
//           this.resetImage();
//           this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
//           this.router.navigate([this.routerLinks]);
//         }
//         if (res['responseJSON'].status == 'failure') {
//           this.loader.hide();
//           this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
//         }
//       })
//     } else {
//       if (this.editVehicelForm.valid && this.updateValues.length == 0) {
//         this.swal.swalFunction('warning', "warning", "Please make any change and update!", 6000);
//       }
//     }
//   }
//   resetImage() {
//     this.imageData = undefined;
//     this.fcImage = undefined;
//     this.pucImage = undefined;
//     this.insuranceImage = undefined;
//   }
//   previewImage(imageUrl) {
//     // this.imageUrl = image;
//     if (imageUrl.startsWith('data:image')) {
//       // Open the base64 image in a new tab
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
//         newWindow.document.title = "Image Preview";
//       }
//     } else {
//       window.open(imageUrl, '_blank');
//     }
//   }
//   openPdf(pdfUrl: string) {
//     if (pdfUrl.startsWith('data:application/pdf;base64,')) {
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`
//           <html>
//             <head>
//               <title>PDF Preview</title>
//             </head>
//             <body style="margin: 0; padding: 0; overflow: hidden;">
//               <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
//             </body>
//           </html>
//         `);
//       }
//     } else {
//       // Handle URL-based PDF
//       window.open(pdfUrl, '_blank');
//     }
//   }

//   invalidDateDateValidator(): ValidatorFn {
//     return (control: AbstractControl): { [key: string]: any } | null => {
//       const selectedDate = new Date(control.value);
//       const currentDate = new Date();

//       // Set the current date's time to 00:00:00 to compare only the date portion
//       currentDate.setHours(0, 0, 0, 0);

//       // If selectedDate is less than currentDate, return an error object
//       return selectedDate < currentDate ? { 'invalidDate': true } : null;
//     };
//   }

//   truncateFilename(filename: string | undefined): string {
//     if (!filename) return '';
//     if (filename.length <= 20) return filename;
//     return filename.substr(0, 10) + '...' + filename.substr(filename.length - 7);
//   }
// }

import { E } from '@angular/cdk/keycodes';
import { ConditionalExpr } from '@angular/compiler';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { MapService } from 'src/app/Services/map.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-editvehicle',
  templateUrl: './editvehicle.component.html',
  styleUrls: ['./editvehicle.component.css']
})
export class EditvehicleComponent implements OnInit {

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };
  matFormSize = '13px';
  editVehicelForm: FormGroup;
  orgID: string;
  vendorID: string;
  vehicleID: string;
  EditFormData: any;
  public mapObj: any;

  isLocationMandatory: boolean = true;

  public vehicleEditObj = {};
  isShowSimno = false;
  isShowVendorName = false;
  public ignoreBoxUpdate: boolean = true;
  strDate: any;
  purchDate: any;
  rcStrDate: any;
  roadTaxStatus: any;

  public editLocation: boolean = true;
  public vehicleLocation = {};
  public locationData = {};

  VendorInfos: any;
  routerLinks: any;

  //for remarks field 
  public isRemarksShown: boolean = false;
  //update
  public remarkError: any = 'You must change the remarks';
  public showRemarkError: boolean = false;

  public fieldOptions = {
    model: [
      { name: "Hatchback", value: "Hatchback", capacity: 3, max: 3 },
      { name: "Sedan", value: "Sedan", capacity: 4, max: 4 },
      { name: "SUV", value: "SUV", capacity: 7, max: 7 },
      { name: "Van", value: "Van", capacity: 15, max: 15 },
      { name: "Bus", value: "Bus", capacity: 60, max: 60 },
      { name: "Auto", value: "Auto", capacity: 3, max: 3 },
      { name: "Load Vehicle", value: "loadVehicle", capacity: 2, max: 100 }
    ],
  };

  public updateValues = [];
  formSubmit: boolean = false;
  public errorObject: any = {};

  // rc
  imageData: File | string = null;
  filePreview: string | null = null;
  rcContentType: string | null = null;
  @ViewChild('rcfile') rcfile: ElementRef;

  // fc
  fcImage: File | string = null;
  fcPreview: string | null = null;
  fcContentType: string | null = null;
  @ViewChild('fcfile') fcfile: ElementRef;

  // puc
  pucImage: File | string = null;
  pucPreview: string | null = null;
  pucContentType: string | null = null;
  @ViewChild('pucfile') pucfile: ElementRef;

  // ins 
  insuranceImage: File | string = null;
  insPreview: string | null = null;
  insContentType: string | null = null;
  @ViewChild('insurancefile') insurancefile: ElementRef;

  /* Branch field */
  public branchLists: any = [];
  public selectedBranch = [];
  @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
  branchSearchChangeObserver: any;
  public enableBranchField: boolean = false;
  public branchSearchVal: any = '';

  public status: any = '';
  public remarks: any = '';
  public viewOption: any = '';
  public pageTitle: string = 'Edit Vehicle'; // New: switch title between edit/view mode
  public isStatusChanged: boolean = false;
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  public vehCapacity: any = {};
  fuelType: any;
  updateFile: boolean;
  updateFileFc: boolean;
  updateFileIns: boolean;
  updateFilePuc: boolean;
  imageUrl: any = [];
  minDate: Date;
  safePdfUrl: any;
  constructor(
    public api: ApiService,
    public router: Router,
    public route: ActivatedRoute,
    public swal: SweetAlert,
    public sub: SharedService,
    public fb: FormBuilder,
    private mapService: MapService,
    public file: FileUploadService,
    public storage: StorageService,
    public comService: CommonServices,
    private renderer: Renderer2,
    public el: ElementRef,
    private sanitizer: DomSanitizer,
    public loader:LoaderService
  ) {

    this.route.paramMap.subscribe((params: any) => {
      this.vendorID = params.params.vendorID;
      this.vehicleID = params.params.vehicleID;
      if (params.params['view']) this.viewOption = params.params.view;

    });
    this.orgID = this.storage.get('userInfo').orgID;
    this.VendorInfos = this.storage.get('vendorID_orgID');

    let vendorName = this.VendorInfos['vendorName'];
    if (vendorName) {
      vendorName = this.comService.strTruncate(vendorName, 13);
      this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
    } else {
      this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
    }
    this.breadcrumbData['Vehicles'] = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
    // OLD:
    // this.breadcrumbData['Edit'] = '';

    // New: switch title and breadcrumb label based on route mode
    if (this.viewOption == 'view') {
      this.pageTitle = 'View Vehicle';
      this.breadcrumbData['View'] = '';
    } else {
      this.pageTitle = 'Edit Vehicle';
      this.breadcrumbData['Edit'] = '';
    }

    this.routerLinks = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
    // const fileInput = this.fileInput.nativeElement as HTMLInputElement;
    // this.renderer.setProperty(fileInput, 'value', '');

  }

  ngOnInit(): void {
    this.getVehCapacity();
    this.getBranchList();
    this.editFormLoad();
    this.getVehicleData();
    this.minDate = new Date()
  }
  editFormLoad() {
    this.editVehicelForm = new FormGroup({
      vehRegNo: new FormControl('', [Validators.required, Validators.pattern('[A-Z|a-z]{2}[0-9]{1,2}[A-Z|a-z]{0,2}[0-9]{4}')]),
      imei: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[0-9|a-z|A-Z]*$')]),
      make: new FormControl(''), /* , [Validators.required]), */
      model: new FormControl('', [Validators.required]),
      capacity: new FormControl('', [Validators.required, Validators.min(1), Validators.max(100)]),
      branch: new FormControl('', [Validators.required]),
      vehicleType: new FormControl('', [Validators.required]),
      chassisNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
      engineNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
      vehRegDate: new FormControl('', [Validators.required]),
      routePermitNo: new FormControl(''),
      startDate: new FormControl(''), /* [Validators.required]), */
      expiryDate: new FormControl(''), /* [Validators.required]), */
      rcNo: new FormControl(''), /* [Validators.required]), */
      vehicleInfo: new FormControl(''), /* [Validators.required]), */
      location: new FormControl('', [Validators.required]),
      isActive: new FormControl('', [Validators.required]),
      remarks: new FormControl({ value: this.remarks, disabled: true }, [Validators.required]),
      boxType: new FormControl('', [Validators.required]),
      roadTaxStatus: new FormControl(''), /* [Validators.required]), */
      fuelType: new FormControl('', [Validators.required]),
      fcfile: new FormControl(null),/* [Validators.required]), */
      insurancefile: new FormControl(null),/* [Validators.required]), */
      pucfile: new FormControl(null),/* [Validators.required]), */
      rcfile: new FormControl(null), /* [Validators.required]), */
      rcStartDate: new FormControl('', [Validators.required]),
      rcExpiryDate: new FormControl('', [Validators.required]),
      pucExpiryDate: new FormControl('', [Validators.required]),
      fcExpiryDate: new FormControl('', [Validators.required]),
      insuranceExpiryDate: new FormControl('', [Validators.required]),
    });
    if (this.viewOption == 'view') {
      this.editVehicelForm.get('imei')?.disable()
      const controlNames = Object.keys(this.editVehicelForm.controls);
      controlNames.forEach(controlName => {
        this.editVehicelForm.get(controlName)?.disable();
      });
    }
  }


  getVehicleData() {

    const obj = {
      orgID: this.orgID,
      vendorID: this.vendorID,
      vehicleID: this.vehicleID
    };

    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        const obj = res.data[0];
        this.EditFormData = res.data[0];
        const data = res.data[0];

        this.status = data['isActive'];
        this.setValueEditVehicleForm(data);
      }
    }).catch((err) => {
      console.log(err);
    });

  }
  getVehCapacity() {
    this.api.transportManagerVehicleCapacity({}).then((res: any) => {
      if (res.status == 'success' && res.data.length > 0 && res.data[0].vehicleTypes.length > 0) {
        this.vehCapacity = res.data[0].vehicleTypes;
        this.fuelType = res.data[0].fuelType;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  setValueEditVehicleForm(data) {
    if (data['boxType'] && data['boxType'] != '') this.onChangeBoxType({ value: data['boxType'] }, 'boxType');
    if (data['model'] && data['model'] != '') this.patchVehicleCapacity({ value: data['model'] }, 'patch');
    if (data['location'] && data['location'] != '') this.locationData = { ...data['location'] };

    (data['rcfile'] && data['rcfile'] != '') && (data['rcContentType'] != undefined) ? this.rcContentType = data['rcContentType'] : data['rcContentType'] == undefined ? this.rcContentType = 'Image' : '';

    data['fcfile'] && data['fcfile'] != '' && (data['fcContentType'] != undefined) ? this.fcContentType = data['fcContentType'] : data['fcContentType'] == undefined ? this.fcContentType = 'Image' : '';

    data['pucfile'] && data['pucfile'] != '' && (data['pucContentType'] != undefined) ? this.pucContentType = data['pucContentType'] : data['pucContentType'] == undefined ? this.pucContentType = 'Image' : '';

    data['insfile'] && data['insfile'] != '' && (data['insContentType']) ? this.insContentType = data['insContentType'] : data['insContentType'] == undefined ? this.insContentType = 'Image' : '';

    this.imageData = this.filePreview = data['rcfile'] && data['rcfile'] !== '' ? data['rcfile'] + '?ts=' + Date.now() : '';

    this.fcImage = this.fcPreview = data['fcfile'] && data['fcfile'] !== '' ? data['fcfile'] + '?ts=' + Date.now() : '';

    this.pucImage = this.pucPreview = data['pucfile'] && data['pucfile'] !== '' ? data['pucfile'] + '?ts=' + Date.now() : '';

    this.insuranceImage = this.insPreview = (data['insfile'] && data['insfile'] !== '') || (data['insurancefile'] && data['insurancefile'] !== '')
      ? (data['insfile'] || data['insurancefile']) + '?ts=' + Date.now()
      : '';

    if (data['branch'] && !Array.isArray(data['branch'])) this.getBranchList('', data['branch']);

    this.remarks = data['msgLog'] && data['msgLog'].length > 0 && data['msgLog'][data['msgLog'].length - 1] && data['msgLog'][data['msgLog'].length - 1]['msg'] ? data['msgLog'][data['msgLog'].length - 1]['msg'] : '';

    this.editVehicelForm.patchValue({
      vehRegNo: data['vehRegNo'] ? data['vehRegNo'] : '--',
      imei: data['imei'] ? data['imei'].toLowerCase() : '--',
      make: data['make'] ? data['make'] : '--',
      model: data['model'] ? data['model'] : '--',
      capacity: data['capacity'] ? data['capacity'] : '--',
      branch: data['branch'] ? data['branch'] : '--',
      vehicleType: data['vehicleType'] ? data['vehicleType'] : '--',
      chassisNo: data['chassisNo'] ? data['chassisNo'] : '--',
      engineNo: data['engineNo'] ? data['engineNo'] : '--',
      vehRegDate: data['vehRegDate'] ? new Date(data['vehRegDate']) : '',
      routePermitNo: data['routePermitNo'] ? data['routePermitNo'] : '--',
      startDate: data['startDate'] ? new Date(data['startDate']) : '',
      expiryDate: data['expiryDate'] ? new Date(data['expiryDate']) : '',
      rcNo: data['rcNo'] ? data['rcNo'] : '--',
      rcStartDate: data['rcStartDate'] ? new Date(data['rcStartDate']) : '',
      rcExpiryDate: data['rcExpiryDate'] ? new Date(data['rcExpiryDate']) : '',
      fcExpiryDate: data['fcExpiryDate'] ? new Date(data['fcExpiryDate']) : '',
      pucExpiryDate: data['pucExpiryDate'] ? new Date(data['pucExpiryDate']) : '',
      insuranceExpiryDate: data['insuranceExpiryDate'] ? new Date(data['insuranceExpiryDate']) : '',
      vehicleInfo: data['vehicleInfo'] ? data['vehicleInfo'] : '--',
      location: data['location'] && data['location']['name'] ? data['location']['name'] : '',
      boxType: data['boxType'] ? data['boxType'] : '--',
      vendorName: data['vendorName'] ? data['vendorName'] : '--',
      simNo: data['simNo'] ? data['simNo'] : '--',
      isActive: data['isActive'] || data.isActive == false ? data.isActive.toString() : '--',
      remarks: this.remarks,
      roadTaxStatus: data['roadTaxStatus'] || data.roadTaxStatus == false ? data.roadTaxStatus.toString() : '--',
      fuelType: data['fuelType'] ? data['fuelType'] : '--',
      rcfile: data['rcfile'] ? data['rcfile'] : '--',
      insurancefile: data['insurancefile'] ? data['insurancefile'] : data['insfile'] ? data['insfile'] : '--',
      pucfile: data['pucfile'] ? data['pucfile'] : '--',
      fcfile: data['fcfile'] ? data['fcfile'] : '--',
    });
    if (data['branch'] && !Array.isArray(data['branch'])) {
      setTimeout(() => {
        this.branchSelectionResult(data['branch']);
      }, 300);
    }
    this.ignoreBoxUpdate = false;
  }

  getBranchList(name?, branch?) {
    this.enableBranchField = false;
    this.branchLists = [];
    const obj = {};
    if (name && name != '') obj['branchName'] = name;
    if (branch) obj['branchID'] = branch;

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter(item => {
            try {
              if (item.branchName && item.branchID) {
                let branchObj = {
                  name: item.branchName,
                  value: item.branchID,
                };
                let pushObj: boolean = true;
                if (this.selectedBranch.length > 0) {
                  this.selectedBranch.map((item) => { if (item.value == branchObj.value) { pushObj = false; } });
                }
                if (pushObj) this.branchLists.push(branchObj);

              }
            } catch (err) {
              console.log('branch', err);
            }
          });
        }
      }
      setTimeout(() => { this.enableBranchField = true }, 200);
    }).catch((err) => {
      // console.log(err);
    });
  }

  // search
  branchSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.branchSearchChangeObserver) {
      new Observable(observer => {
        this.branchSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getBranchList(term);
        });
    }

    this.branchSearchChangeObserver.next(searchValue);
  }

  branchSelectionResult(value) {
    if (!Array.isArray(value)) value = [value];
    let result = [];
    let removedResult = [];
    for (let i = 0; i < value.length; i++) {
      let val = value[i];
      this.selectedBranch.map((item) => {
        if (item.value == val) {
          let valIndex = result.findIndex((e) => e.value == item.value);
          if (valIndex == -1) result.push(item);
        }
      })
      this.branchLists.map((veh) => {
        if (veh.value == val) {
          let valIndex = result.findIndex((e) => e.value == veh.value);
          if (valIndex == -1) result.push(veh);
        }
      })
    }
    this.selectedBranch.map((branch) => {
      if (!value.includes(branch.value)) {
        let pushObj: boolean = true;
        removedResult.map((e) => { if (e.value == branch.value) pushObj = false; });
        if (pushObj) removedResult.unshift(branch);
      }
    })
    this.enableBranchField = false;
    this.branchLists = [...removedResult, ...this.branchLists]
    this.enableBranchField = true;

    this.selectedBranch = [...result];
    if (this.branchSearchTextBox && this.branchSearchTextBox.nativeElement)
      this.branchSearchTextBox.nativeElement.value = '';
    this.clearDuplicates();
  }

  clearDuplicates() {
    let result = [];
    this.enableBranchField = false;
    this.branchLists.map((branchObj) => {

      let pushObj: boolean = true;
      this.selectedBranch.map((item) => { if (item.value == branchObj.value) pushObj = false; });
      if (pushObj) result.push(branchObj);

    });
    this.branchLists = [...result];
    this.enableBranchField = true;
  }

  clearBranchSearch(event) {
    this.branchSearchTextBox.nativeElement.value = '';
    this.getBranchList();
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }

  patchVehicleCapacity(e, type) {
    this.fieldOptions['model'].filter((option: any) => {
      if (option.value == e.value) {
        this.editVehicelForm.controls['capacity'].setValidators([Validators.required, Validators.min(1), Validators.max(option.max)])
        if (type != 'patch') this.editVehicelForm.controls['capacity'].patchValue(option.capacity);
        if (type == 'update') this.updateField('capacity', parseInt(option.capacity));
      }
    })
  }

  onChangeBoxType(e, field) {
    // console.log('boxValue',e.value);
    this.isShowVendorName = false;
    this.isShowSimno = false;
    if (e.value == 'others') {
      this.editVehicelForm.removeControl('simNo');
      this.editVehicelForm.addControl('vendorName', new FormControl('')); /* , [Validators.required])); */
      this.isShowVendorName = true;

      if(this.viewOption==='view') {
        this.editVehicelForm.get('vendorName')?.disable(); // ✅ FIX
      }
    }
    if (e.value == 'G10 Gps Device') {
      this.editVehicelForm.removeControl('vendorName');
      this.editVehicelForm.addControl('simNo', new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13)]));
      this.isShowSimno = true;
    }

    if (this.viewOption == 'view') {
    this.editVehicelForm.get('simNo')?.disable(); // ✅ FIX
  }

    if (!this.ignoreBoxUpdate) this.fieldChange(e, 'dropdown', field);

  }

  getLocation(obj) {
    if(this.viewOption == 'view') return; 

    this.vehicleLocation = { ...obj };
    this.fieldChange(this.vehicleLocation, 'location', 'location');
  }

  // file upload--------------

  async handleUpload(event: Event, type: string) {
    const file = (event.target as HTMLInputElement).files?.[0];
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const allowedPdfType = 'application/pdf';

    if (!file) return;

    const fileType = file.type;
    const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

    if (!isImageOrPdf) {
      this.handleInvalidFileType(type);
      return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
    }

    if (file.size > maxFileSize) {
      this.handleFileSizeExceeded(type);
      return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
    }

    this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

    if (this.formSubmit) this.validation();
  }

  private processFile(file: File, type: string, fileType: string, contentType: string) {
    const fileReader = new FileReader();
    fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
    fileReader.readAsDataURL(file);
  }

  private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
    switch (type) {
      case 'rcfile':
        this.imageData = file;
        this.rcContentType = contentType;
        this.filePreview = previewData;
        this.updateFile = true;
        this.editVehicelForm.controls.rcfile.patchValue(file);
        break;
      case 'fcfile':
        this.fcImage = file;
        this.fcContentType = contentType;
        this.fcPreview = previewData;
        this.updateFileFc = true;
        this.editVehicelForm.controls.fcfile.patchValue(file);
        break;
      case 'pucfile':
        this.pucImage = file;
        this.pucContentType = contentType;
        this.pucPreview = previewData;
        this.updateFilePuc = true;
        this.editVehicelForm.controls.pucfile.patchValue(file);
        break;
      case 'insurancefile':
        this.insuranceImage = file;
        this.insContentType = contentType;
        this.insPreview = previewData;
        this.updateFileIns = true;
        this.editVehicelForm.controls.insurancefile.patchValue(file);
        break;
    }
  }

  private handleInvalidFileType(type: string) {
    this.resetFileFields(type);
  }

  private handleFileSizeExceeded(type: string) {
    this.resetFileFields(type);
  }

  private resetFileFields(type: string) {
    switch (type) {
      case 'rcfile':
        this.imageData = null;
        this.filePreview = null;
        this.rcContentType = null;
        this.editVehicelForm.controls.rcfile.reset();
        this.clearInputField(this.rcfile);
        break;
      case 'fcfile':
        this.fcImage = null;
        this.fcPreview = null;
        this.fcContentType = null;
        this.editVehicelForm.controls.fcfile.reset();
        this.clearInputField(this.fcfile);
        break;
      case 'pucfile':
        this.pucImage = null;
        this.pucPreview = null;
        this.pucContentType = null;
        this.editVehicelForm.controls.pucfile.reset();
        this.clearInputField(this.pucfile);
        break;
      case 'insurancefile':
        this.insuranceImage = null;
        this.insPreview = null;
        this.insContentType = null;
        this.editVehicelForm.controls.insurancefile.reset();
        this.clearInputField(this.insurancefile);
        break;
    }
  }

  private clearInputField(inputElement: ElementRef) {
    if (inputElement) inputElement.nativeElement.value = '';
  }

  private showErrorMessage(message: string) {
    this.swal.swalFunction('error', 'error', message, 5000);
  }

  reUpload(field: string) {
    const fileFieldMap = {
      'rcfile': this.rcfile,
      'fcfile': this.fcfile,
      'pucfile': this.pucfile,
      'insurancefile': this.insurancefile
    };

    const fileInput = fileFieldMap[field];
    if (fileInput) {
      fileInput.nativeElement.click();
    }
  }

  cancelImage(type: string) {
    if (type == 'rcfile') {
      this.editVehicelForm.controls.rcfile.patchValue('');
      this.imageData = undefined;
    } if (type == 'fcfile') {
      this.editVehicelForm.controls.fcfile.patchValue('');
      this.fcImage = undefined;
    } if (type == 'pucfile') {
      this.editVehicelForm.controls.pucfile.patchValue('');
      this.pucImage = undefined;
    } if (type == 'insurancefile') {
      this.editVehicelForm.controls.insurancefile.patchValue('');
      this.insuranceImage = undefined;
    }
  }

  // check Error in form field
  public checkError = (controlName: string, errorName: string) => {
    if (errorName == 'matDatepickerMin') {
    }
    return this.editVehicelForm.controls[controlName].hasError(errorName);
  }
  validation() {
    this.errorObject = {};
    let fields = Object.keys(this.editVehicelForm.controls);
    fields.map((field) => {
      if (this.checkError(field, 'required')) {
        this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required';
        if (field == 'vehRegNo') this.errorObject[field] = 'Registration No is required';
        else if (field == 'imei') this.errorObject[field] = 'IMEI is required';
        else if (field == 'vehicleType') this.errorObject[field] = 'Vehicle Type is required';
        else if (field == 'chassisNo') this.errorObject[field] = 'Chassis No is required';
        else if (field == 'engineNo') this.errorObject[field] = 'Engine No is required';
        else if (field == 'vehRegDate') this.errorObject[field] = 'VEhicle Registration Date is required';
        else if (field == 'routePermitNo') this.errorObject[field] = 'Route Permit No is required';
        else if (field == 'startDate') this.errorObject[field] = 'Start Date is required';
        else if (field == 'expiryDate') this.errorObject[field] = 'Expiry Date is required';
        else if (field == 'rcNo') this.errorObject[field] = 'RC Book No is required';
        else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start Date is required';
        else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC Expiry Date is required';
        else if (field == 'vehicleInfo') this.errorObject[field] = 'Vehicle Info is required';
        else if (field == 'boxType') this.errorObject[field] = 'Box Type is required';
        else if (field == 'isActive') this.errorObject[field] = 'Status is required';
        else if (field == 'remarks') this.errorObject[field] = 'Remarks is required';
        else if (field == 'vendorName') this.errorObject[field] = 'Vendor Name is required';
        else if (field == 'simNo') this.errorObject[field] = 'SIM No is required';
        else if (field == 'roadTaxStatus') this.errorObject[field] = 'Road Tax Paid is required';
        else if (field == 'rcfile') this.errorObject[field] = 'RC File is required';
        else if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date  is required';
        else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date is required';
        else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date is required';
        else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date is required';
        else if (field == 'fuelType') this.errorObject[field] = 'Fuel type is required';
        else if (field == 'location') this.errorObject[field] = 'Location is required';
        else if (field == 'vehRegDate') this.errorObject[field] = 'Vehicle Registration Date is required';
      }
      else if (field == 'vehRegNo') {
        if (this.checkError(field, 'pattern')) this.errorObject[field] = 'Registration No is Incorrect';
      } else if (field == 'imei' || field == 'chassisNo' || field == 'engineNo' || field == 'routePermitNo') {
        if (this.checkError(field, 'minlength')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be above 3 characters";
          else if (field == 'chassisNo') this.errorObject[field] = "Chassis No should be more than 17 characters";
          else if (field == 'engineNo') this.errorObject[field] = "Engine No should be more than 17 characters";
          else if (field == 'routePermitNo') this.errorObject[field] = "Route Permit Cost should be minimum than 4 digits";
        } else if (this.checkError(field, 'maxlength')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be less than 50 characters";
          else if (field == 'routePermitNo') this.errorObject[field] = "Route Permit Cost should be more than 7 digits";
        }
        else if (this.checkError(field, 'pattern')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be valid";
        }
      } else if (field == 'capacity') {
        if (this.checkError(field, 'min')) this.errorObject[field] = "Minimum capacity is required";
        else if (this.checkError(field, 'max')) this.errorObject[field] = "Maximum capacity is reached";
      }
      if (['rcStartDate', 'fcExpiryDate', 'pucExpiryDate', 'insuranceExpiryDate', 'rcExpiryDate'].includes(field) && this.editVehicelForm.get(field).value) {
        const selectedDate = new Date(this.editVehicelForm.get(field).value);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Only compare the date part, ignore time

        if (selectedDate < currentDate) {
          if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date must not be in the past';
          else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date must not be in the past';
          else if (field == 'rcStartDate') this.errorObject[field] = 'RC start date must not be in the past';
          else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date must not be in the past';
          else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date must not be in the past';
        }
      }
      else if (field == 'remarks' || field == 'status') {
        const isInactive = this.editVehicelForm.get('isActive').value === 'false';
        if(isInactive && !this.editVehicelForm.value.remarks){
          this.errorObject
        }
        if (this.isStatusChanged) {
          if (this.EditFormData.remarks == this.editVehicelForm.value.remarks) {
            this.errorObject.remarks = 'You must change the remarks';
            this.editVehicelForm.controls['remarks'].setErrors({ 'incorrect': true });
          }
        }
      }
    })
  }

  /* update unique field*/
  fieldChange(e: any, type, field) {
    let value: any;
    if (type == 'text' || type == 'textarea') {
      value = e.target.value;
      if (field == 'vehRegNo') value = String(e.target.value).toUpperCase();
      if (field == 'simNo') value = parseInt(value);
      if (field == 'remarks') {
        if (!this.isStatusChanged) value = this.remarks;
      }
    }
    if (type == 'date') {
      value = new Date(e.value).getTime();
    }
    if (type == 'dropdown') {
      value = e.value;
      if (field == 'roadTaxStatus') {
        if (value == 'true') value = true;
        else value = false;
      }
      if (field == 'model') {
        this.patchVehicleCapacity(e, 'update');
      }
      if (field == 'branch') {
        this.branchSelectionResult(value);
      }
      if (field == 'isActive') {
        this.isStatusChanged = true;
        const isInactive = value === 'false';
        //let remarks: any = this.editVehicelForm.get('remarks');
        if (this.status === (value === 'true')) {
          this.isStatusChanged = false;
          this.editVehicelForm.patchValue({
            remarks: this.remarks
          });
          this.editVehicelForm.controls['remarks'].disable();
          // this.editVehicelForm.addControl('remarks', new FormControl({ value: this.remarks, disabled: true }, [Validators.required]));
        } else {
          const remarksControl = this.editVehicelForm.get('remarks');
          remarksControl.reset(''); 
          remarksControl.enable();
          
          if(isInactive){
            remarksControl.setValidators([Validators.required]);
          }
          else{
            remarksControl.clearValidators();
          }
          remarksControl.updateValueAndValidity();
          // this.editVehicelForm.controls['remarks'].enable();
          // this.editVehicelForm.addControl('remarks', new FormControl({ value: '', disabled: false }));
        }
      }
    }
    if (type == 'location' || type == 'file') {
      value = e;
    }
    if (field && (value != undefined)) this.updateField(field, value);
    if (this.formSubmit) this.validation();
  }

  updateField(field, value) {
    let editObjKeys = Object.keys(this.EditFormData);

    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      if (field == 'isActive') {
        obj.value = (value === 'true');
      }
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]
    }
    else {
      let obj = { field: field, value: value, };
      if (field == 'isActive') {
        obj.value = (value === 'true');
      }
      this.updateValues.push(obj);
    }
    for (let i = 0; i < editObjKeys.length; i++) {
      for (let j = 0; j < this.updateValues.length; j++) {
        if (editObjKeys[i] === this.updateValues[j]['field'] && this.EditFormData[editObjKeys[i]] === this.updateValues[j]['value']) {
          const index = this.updateValues.findIndex(e => (e.field == editObjKeys[i] && e.value == this.EditFormData[editObjKeys[i]]))
          this.updateValues.splice(index, 1);
        }
      }
    }
  }

  onFileSelected(event: any) {
    const fileInput = this.fileInput.nativeElement as HTMLInputElement;
    this.renderer.setProperty(fileInput, 'value', '');
  }
  onSubmit() {
    this.formSubmit = true;
    this.validation();
  
    this.editVehicelForm.markAllAsTouched();
    // if (!this.editVehicelForm.valid) return;
    if (this.editVehicelForm.valid && (this.updateValues.length > 0 || this.updateFile == true || this.updateFileFc == true || this.updateFileIns == true || this.updateFilePuc == true)) {
      const obj = {
        orgID: this.orgID,
        vendorID: this.vendorID,
        vehicleID: this.vehicleID,
        vehRegNo: this.editVehicelForm.value['vehRegNo'],
      };

      this.updateValues.filter((e) => {
        obj[e.field] = e.value;
      });
      if (this.updateFile == true) {
        obj['rcFiles'] = this.imageData;
        obj['rcContentType'] = this.rcContentType;
      }
      if (this.updateFileFc == true) {
        obj['fcFiles'] = this.fcImage;
        obj['fcContentType'] = this.fcContentType;
      };
      if (this.updateFileIns == true) {
        obj['insFiles'] = this.insuranceImage;
        obj['insContentType'] = this.insContentType;
      }
      if (this.updateFilePuc == true) {
        obj['pucFiles'] = this.pucImage;
        obj['pucContentType'] = this.pucContentType;
      };

      delete obj['pucfile'];
      delete obj['fcfile'];
      delete obj['rcfile'];
      delete obj['insurancefile'];

      let url = 'organization/vehicle/updateVehicle';
      this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
        if (res['responseJSON']['status'] == 'success') {
          this.resetImage();
          this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
          this.router.navigate([this.routerLinks]);
        }
        if (res['responseJSON'].status == 'failure') {
          this.loader.hide();
          this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
        }
      })
    } else {
      if (this.editVehicelForm.valid && this.updateValues.length == 0) {
        this.swal.swalFunction('warning', "warning", "Please make any change and update!", 6000);
      }
    }
  }
  resetImage() {
    this.imageData = undefined;
    this.fcImage = undefined;
    this.pucImage = undefined;
    this.insuranceImage = undefined;
  }
  previewImage(imageUrl) {
    // this.imageUrl = image;
    if (imageUrl.startsWith('data:image')) {
      // Open the base64 image in a new tab
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
        newWindow.document.title = "Image Preview";
      }
    } else {
      window.open(imageUrl, '_blank');
    }
  }
  openPdf(pdfUrl: string) {
    if (pdfUrl.startsWith('data:application/pdf;base64,')) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head>
              <title>PDF Preview</title>
            </head>
            <body style="margin: 0; padding: 0; overflow: hidden;">
              <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
            </body>
          </html>
        `);
      }
    } else {
      // Handle URL-based PDF
      window.open(pdfUrl, '_blank');
    }
  }

  invalidDateDateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const selectedDate = new Date(control.value);
      const currentDate = new Date();

      // Set the current date's time to 00:00:00 to compare only the date portion
      currentDate.setHours(0, 0, 0, 0);

      // If selectedDate is less than currentDate, return an error object
      return selectedDate < currentDate ? { 'invalidDate': true } : null;
    };
  }

  truncateFilename(filename: string | undefined): string {
    if (!filename) return '';
    if (filename.length <= 20) return filename;
    return filename.substr(0, 10) + '...' + filename.substr(filename.length - 7);
  }
}
